// extracted by mini-css-extract-plugin
export default {"myworkContainer":"mywork_myworkContainer__Hn+H+","headerbox":"mywork_headerbox__qw089","works":"mywork_works__pWkz-"};